var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"xpress"},[_c('CreateAddress',{attrs:{"visible":_vm.isAddressVisible,"user":_vm.user,"establishment":_vm.establishment},on:{"selectAddress":_vm.selectAddress}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }